import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/store/authStore';
import { fetchProfile, updatePhone, updateProfile } from '../apis/profile';

// Per user, so one account's profile never shows up for the next on the same browser
const useProfileKey = () => ['profile', useAuthStore((state) => state.user_id)];

export const useProfile = () => useQuery({ queryKey: useProfileKey(), queryFn: fetchProfile });

export const useSaveProfile = () => {
  const queryClient = useQueryClient();
  const queryKey = useProfileKey();
  return useMutation({
    mutationFn: updateProfile,
    onSuccess: (profile) => {
      queryClient.setQueryData(queryKey, profile);
      // The name in the session profile (Akun, header) may have changed
      queryClient.invalidateQueries({ queryKey: ['session-profile'] });
    },
  });
};

export const useChangePhone = () => {
  const queryClient = useQueryClient();
  const queryKey = useProfileKey();
  return useMutation({
    mutationFn: updatePhone,
    onSuccess: (profile) => queryClient.setQueryData(queryKey, profile),
  });
};
